import { ShiftOfferCancelReason } from '@caresend/types';
import { isInEnum } from '@caresend/utils';
import { defineComponent, ref, computed } from 'vue';
import __vue_component__ from '../../../../../components/alerts/Alert.vue.js';
import __vue_component__$1 from '../../../../../components/buttons/ButtonComponent/ButtonComponent.vue.js';
import '@sentry/vue';
import { toastError } from '../../../../../functions/toast/toast.js';
import '@fortawesome/fontawesome-svg-core';
import 'buefy';
import '../../../../../components/ui/Icon.vue.js';
import '../../../../../functions/configuration/icons.js';
import '../../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../../functions/tracking/index.js';
import { cancelShift } from '../../../../../functions/shifts.js';
import 'immutability-helper';
import { getRouter } from '../../../../../router/helpers/initRouter.js';
import '../../../../../router/routes/dev/model.js';
import '../../../../../router/routes/dev/routes.js';
import '../../../../../router/routes/dashboard/model.js';
import '../../../../../router/routes/pro/model.js';
import '../../../../../router/routes/visitsPage/model.js';
import '../../../../../router/routes/orderFlow/model.js';
import '../../../../../router/routes/orderFlow/privateHelpers.js';
import '../../../../../router/routes/orderFlow/routes.js';
import '../../../../../router/routes/schedulingFlow/model.js';
import '../../../../../router/routes/schedulingFlow/routes.js';
import '../../../../../router/routes/chartingFlow/model.js';
import '../../../../../router/routes/chartingFlow/routes.js';
import '../../../../../router/routes/portal/portalRoutes.js';
import { portalAssignRoute } from '../../../../../router/routes/portal/locations.js';
import '../../../../../router/routes/portal/model.js';
import '../../../../../router/routes/visitsPage/routes.js';
import { getStore } from '../../../../helpers/initStore.js';
import { isSchedulingDryRun } from '../../helpers/index.js';

var script = defineComponent({
    name: 'NurseCancelReschedule',
    components: {
        Alert: __vue_component__,
        ButtonComponent: __vue_component__$1,
    },
    props: {
        shiftID: {
            type: String,
            required: true,
        },
        shiftCancelReason: {
            type: String,
            default: undefined,
        },
    },
    setup(props) {
        const store = getStore();
        const router = getRouter();
        const isAlertOpen = ref(false);
        const draftWaypoint = computed(() => store.state.schedulingFlow.draftWaypoint);
        const procedureIDs = computed(() => draftWaypoint.value ? Object.keys(draftWaypoint.value.procedures) : []);
        const isDraftWaypointDryRun = computed(() => draftWaypoint.value ? isSchedulingDryRun(draftWaypoint.value) : false);
        const handleClick = async () => {
            if (!props.shiftCancelReason || !isInEnum(props.shiftCancelReason, ShiftOfferCancelReason)) {
                toastError('Invalid cancel reason');
                await router.push(portalAssignRoute(props.shiftID));
                return;
            }
            await cancelShift({
                shiftID: props.shiftID,
                cancelReason: props.shiftCancelReason,
                procedureIDs: procedureIDs.value,
                isRescheduling: false,
                isDryRun: isDraftWaypointDryRun.value,
            });
        };
        return {
            handleClick,
            isAlertOpen,
        };
    },
});

export { script as default };
